// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ahGsg","approved":"Status_approved__301VG","rejected":"Status_rejected__3AYmb","expired":"Status_expired__1ZxDW","label":"Status_label__1hg3F"};